export enum AnnouncementStatus {
  /**
   * 已保存
   */
  SAVED = 0,

  /**
   * 待发布
   */
  WAIT_PUBLISH = 2,

  /**
   * 已发布
   */
  PUBLISHED = 1
}

export const AnnouncementStatusTextMap = {
  [AnnouncementStatus.SAVED]: '已保存',
  [AnnouncementStatus.WAIT_PUBLISH]: '待发布',
  [AnnouncementStatus.PUBLISHED]: '已发布'
}
